export const tabsStyled = {
  minHeight: "40px",
  mx: { xs: 2, md: 0 },
  "& .MuiTabs-scroller": {
    display: "flex",
  },
  "& .MuiTabs-list": {
    border: "1px solid",
    borderColor: "#DDDDDD",
    borderRadius: 1,
    flexDirection: { xs: "column", md: "row" },
    alignItems: { xs: "stretch", md: "center" },
    my: { lg: 0.5 },
  },
};

export const tabStyled = {
  py: 0,
  px: 1.5,
  minHeight: "40px",
  color: "var(--text-title-grey)",
  maxWidth: "none",
  alignItems: { xs: "flex-start", md: "center" },
  borderRadius: 1,
  "&.Mui-selected": {
    border: "1px solid",
    borderColor: "primary.main",
  },
};
